import { Record } from 'immutable';

export const AUTH_REDUCER_KEY = 'authStore';

export const AuthTokenData = Record({
  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scope: undefined,

  surveyRequested: undefined,
});

export const AuthSessionSources = Object.freeze({
  SESSION_STORAGE: 'SESSION_STORAGE',
  REDUX_PERSIST: 'REDUX_PERSIST',
  MASTER: 'MASTER',
});

export const mkAuthStore = Record({
  source: undefined, // AuthSessionSources
  qcsId: undefined,
  datasetId: undefined,
  datasetPlatform: undefined,
  datasetSubscriptionTier: undefined,
  datasetCreatedByClientId: undefined,
  datasetCreatedAt: undefined,

  accessToken: undefined,
  accessTokenExpired: undefined,
  refreshToken: undefined,
  refreshTokenExpired: undefined,
  scope: undefined,

  groups: undefined,

  surveyRequested: undefined,

  isLoading: undefined,
  error: undefined,
  isSanitized: undefined,
});

export const AuthSelectDatasetPayload = Record({
  dataset: undefined,

  userChoice: undefined,
  reload: true,
  location: '/',
});
